import { Injectable } from '@angular/core';
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import { environment } from '../../../../environments/environment';
import { NavigationEnd } from '@angular/router';

declare global {
  interface Window {
    datadogRum?: typeof datadogRum;
    DD_RUM?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class DatadogService {
  constructor() {
    this.initializeDatadog();
  }

  private initializeDatadog(): void {
    if (environment.datadog && environment.datadog.env !== 'prod') {
      datadogRum.init({
        clientToken: environment.datadog.clientToken,
        applicationId: environment.datadog.applicationId,
        service: environment.datadog.service,
        env: environment.datadog.env,
        version: environment.datadog.version,

        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,

      });
      window.DD_RUM && window.DD_RUM.setGlobalContextProperty('cbre_details', {
        tower: 'global_advisory',
        lob: 'a&t',
        application: 'finishline',
        apm_id: '400218',
        apm_no: 'apm0001557'
      });
    }
  }

  setUser(id: string = 'no-id', email: string = 'no-email'): void {
    if (window.DD_RUM) {
      window.DD_RUM.setUser({
        id: id,
        email: email,
      });
      if (environment.datadog.env === 'local') {
        console.log(`✅ Datadog user set: ${id}`);
      }
    }
  }

  // Track route changes
  setRouteTracking(event: NavigationEnd): void {
    if (window.DD_RUM) {
      window.DD_RUM.startView(event.url);
      if (environment.datadog.env === 'local') {
        console.log(`Datadog user: ${JSON.stringify(window.DD_RUM.getUser())}`);
        console.log(`🔍 Datadog view tracked: ${event.url}`);
      }
    }
  }

  // Add custom events for business logic tracking
  addAction(actionName: string, context?: any): void {
    if (window.DD_RUM) {
      window.DD_RUM.addAction(actionName, context);
    }
  }

  // Add custom errors for better error tracking  
  addError(error: Error, context?: any): void {
    if (window.DD_RUM) {
      window.DD_RUM.addError(error, context);
    }
  }

  // Add timing measurements
  addTiming(timingName: string, duration: number): void {
    if (window.DD_RUM) {
      window.DD_RUM.addTiming(timingName, duration);
    }
  }

  // Update global context for all events
  setGlobalContext(key: string, value: any): void {
    if (window.DD_RUM) {
      window.DD_RUM.setGlobalContextProperty(key, value);
    }
  }

}
